import React from 'react';
import { images } from 'utils';

const Empty = ({ text, subText, style }) => {

    return (
        <React.Fragment>
            <div id="Empty" className="d-flex justify-content-center align-items-center text-center" style={{ height: '50vh', ...style }}>
                <div>
                    <img src={images.EmptyOrders} alt="EmptyOrders" height="90" style={{ opacity: 1 }} />
                    <div className="fw-600 mt-4">{text}</div>
                    {subText && (<div className="text-muted small">{subText}</div>)}
                </div>
            </div>
        </React.Fragment>
    );
}

export default Empty;